module.exports = __webpack_public_path__ + "assets/img/de-b7dc6d17.png";